import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ErrorPage = ({
  title = null,
  description = null,
}) => {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t('errorPage.defaultTitle');
  const resolvedDescription = description ?? t('errorPage.defaultDescription');
  return (
    <div className="
      flex flex-col
      items-center justify-center
      min-h-full w-full
      bg-gradient-to-br from-gray-900 to-gray-800
      text-white
      px-4
      text-center
    ">
      <h1 className="text-4xl sm:text-5xl font-bold mb-4">
        {resolvedTitle}
      </h1>

      <p className="text-base sm:text-lg mb-6 text-gray-300 max-w-md">
        {resolvedDescription}
      </p>

      <Link
        to="/"
        className="
          px-6 py-3
          bg-indigo-600
          text-white
          rounded-lg
          shadow
          hover:bg-indigo-700
          transition
        "
      >
        {t('errorPage.goBackHome')}
      </Link>
    </div>
  );
};

export default ErrorPage;
